import { render, staticRenderFns } from "./committeeRoomList.vue?vue&type=template&id=f70f64d8&scoped=true"
import script from "./committeeRoomList.vue?vue&type=script&lang=js"
export * from "./committeeRoomList.vue?vue&type=script&lang=js"
import style0 from "./committeeRoomList.vue?vue&type=style&index=0&id=f70f64d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f64d8",
  null
  
)

export default component.exports